import {useEffect} from 'react';

import {useSelector} from 'react-redux';

import {getNameSelectedMethod} from 'desktop/pages/checkout/store/selectors/paymentStep/paymentStep';
import {getPrimerState} from 'desktop/pages/checkout/store/selectors/primer/primer';
import {sendPrimerErrorEvent} from 'desktop/utils/sendPrimerErrorEvent/sendPrimerErrorEvent';

import {PAYMENTS} from './../../../constants/paymentStep';

/**
 * handle preValidate, primer and save order errors in one place
 * handle error analytics for all primer methods
 * */
export const useGetErrorAndSendAnalytics = (code: PAYMENTS) => {
    const {analyticsMessage, uiMessage} = useSelector(getPrimerState);
    const selectedPaymentMethod = useSelector(getNameSelectedMethod);

    const paymentsMethodLabel: {[key in PAYMENTS]?: string} = {
        [PAYMENTS.METHOD_PRIMER]: 'Credit card',
        [PAYMENTS.METHOD_PRIMER_APPLE_PAY]: 'Apple Pay Primer',
        [PAYMENTS.METHOD_PRIMER_GOOGLE_PAY]: 'Google Pay Primer',
        [PAYMENTS.METHOD_PRIMER_KLARNA]: 'Klarna Primer',
        [PAYMENTS.METHOD_PRIMER_PAYPAL]: 'Paypal Primer',
        [PAYMENTS.METHOD_PRIMER_VENMO]: 'Primer Venmo',
    };

    const method = paymentsMethodLabel[selectedPaymentMethod] || '';

    useEffect(() => {
        if (code !== selectedPaymentMethod) return;

        sendPrimerErrorEvent({
            error: analyticsMessage || '',
            method,
        });
    }, [analyticsMessage, method, selectedPaymentMethod, code]);

    return {error: uiMessage};
};
